import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const pains = ['Llegás a la cancha sin saber exactamente qué ejercicio vas a dar ese día', 'Tus alumnos no progresan porque no hay un orden claro de contenidos ni una progresión real', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos sin que alguno se aburra o se frustre', 'Cuando llueve o hay feriado, cancelás la clase y perdés el dinero sin ninguna alternativa', 'No podés justificar un aumento de precio porque no tenés nada sistematizado ni visible para el alumno', 'Llegás a casa agotado después de 8 horas de cancha y todavía tenés que pensar qué dar mañana', 'Nadie valora tu trabajo porque no se ve reflejado en resultados concretos ni en una progresión clara'];
export function PainPoints() {
  return <section className="py-20 bg-white" data-id="element-188">
      <div className="max-w-4xl mx-auto px-4" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-190">
          <h2 className="text-3xl md:text-4xl font-display text-charcoal mb-4" data-id="element-191">
            Si sos profe de tenis, esto te va a sonar conocido:
          </h2>
          <div className="w-24 h-1 bg-clay-orange mx-auto rounded-full" data-id="element-192"></div>
        </motion.div>

        <div className="space-y-4 mb-12" data-id="element-193">
          {pains.map((pain, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="flex items-start gap-4 p-4 rounded-xl hover:bg-red-50/50 transition-colors border border-transparent hover:border-red-100" data-id="element-194">
              <XCircleIcon className="text-red-500 shrink-0 mt-1" size={24} data-id="element-195" />
              <p className="text-lg text-gray-700 font-medium" data-id="element-196">{pain}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center bg-gray-50 p-8 rounded-2xl border border-gray-100" data-id="element-197">
          <p className="text-2xl md:text-3xl font-display text-tennis-green mb-8 italic" data-id="element-198">
            "¿Cuántas clases más vas a improvisar?"
          </p>

          <a href="#precio" className="inline-block w-full sm:w-auto bg-charcoal hover:bg-black text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300" data-id="element-199">
            👉 BASTA DE IMPROVISAR — QUIERO MI TENIS 360
          </a>
        </motion.div>
      </div>
    </section>;
}